import { gql } from "@apollo/client";

// Query to get the weather station status
export const GET_WEATHER_STATION_STATUS = (
    weather_station_id: number, 
    page: number = 1, 
    pageSize: number = 10, 
    order_by: string = "asc"
) => gql`
    query MyQuery {
        its_weather_station_statuses_aggregate(
            where: {
                weather_station_id: {_eq: ${weather_station_id}}
            }
        ) {
            aggregate {
                count
            }
        }
        its_weather_station_statuses(
            where: {
                weather_station_id: {_eq: ${weather_station_id}}
            }, 
            order_by: {id: ${order_by}},
            limit: ${pageSize},
            offset: ${(page - 1) * pageSize}
        ) {
            id
            temperatura_aire: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.2.1.3.1\\\"]")
            temperatura_max: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.5.0\\\"]")
            temperatura_min: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.6.0\\\"]")
            humedad_relativa: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.13.3.0\\\"]")
            presion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.1.7.4.0\\\"]")
            viento_velocidad: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.6.1\\\"]")
            viento_direccion: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.4.8.1.7.1\\\"]")
            punto_rocio: data(path: "$[\\\"1.3.6.1.4.1.1206.4.2.5.2.5.4.0\\\"]")
            created_at
            is_online
        }
    }
`;